import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "archive",
  "use": "archive-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"archive\">\n<path d=\"M21,22H3c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1s1,0.4,1,1v12h16V8c0-0.6,0.4-1,1-1s1,0.4,1,1v13C22,21.6,21.6,22,21,22z\" />\n<path d=\"M23,9H1C0.4,9,0,8.6,0,8V3c0-0.6,0.4-1,1-1h22c0.6,0,1,0.4,1,1v5C24,8.6,23.6,9,23,9z M2,7h20V4H2V7z\" />\n<path d=\"M14,13h-4c-0.6,0-1-0.4-1-1s0.4-1,1-1h4c0.6,0,1,0.4,1,1S14.6,13,14,13z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol